import { keyframes } from '@emotion/css';
import { StyleEntry } from 'Shared/backend/styleUtils';
import { ShowForegroundOnTimer } from 'Shared/themes/ShowForegroundOnTimer';


export function transitionsStyles(sizes,_text): {[name: string]: StyleEntry}
{
	return {
		'Parallax': {
			explanation: 'Scroll the contents at a different rate to the page scroll. Useful effect when applied to images that have text or logos overlayed. Sometimes used in banners and featured items.',

			rules: [{
				location: () => ['*'],
				parallax: () => true
			}]
		},

		'Fade in': {
			explanation: 'Fade the child in the first time it scrolls into view.',

			rules: [{
				location: () => ['*'],

				css: () => ({
					transition: 'opacity 1s',
					opacity: 0.1,
				}),

				animations: () => [{
					type: 'enableOnce',
					options: {threshold: 0.3},
					css: {
						opacity: 1.0,
					}
				}]
			}]
		},

		'Fade in foreground on hover': {
			explanation: 'Fade in the foreground of an overlay on hover.',

			//XXX cf defaults
			rules: [{
				location: () => ['*'],

				css: () => ({
					[`@container (min-width:${sizes.flipToOneColumn}px)`]: {
						'> :nth-child(2)': {

							opacity: 0, //CJ added to hide foreground until hover. 0.2 ease slows the 'hide' when hover is taken away
							transition: 'opacity .5s',

							'&:hover': {
								animationName: 'unset',
								opacity: '1.0',
								transition: 'opacity 0.2s',
							}
						}
					},

					[`@container (max-width:${sizes.flipToOneColumn}px)`]: {
						'> :nth-child(2)': {
							opacity: 0.1,
							transition: 'opacity 0.2s',
						}
					},
				}),

				animations: () => [{
					type: 'enable',
					options: {threshold: 0.6},
					css: {
						[`@container (max-width:${sizes.flipToOneColumn}px)`]: {
							'> :nth-child(2)': {
								opacity: 1.0,
								transition: 'opacity 0.5s',
							}
						}
					}
				}]
			}]
		},


		///

		'Show foreground on timer': {
			explanation: 'Shows and hides the foregrounds of the overlays in a grid based on a timer.',

			ui: ShowForegroundOnTimer,
			//XXX cf defaults

			rules: [{
				location: () => ['*'],

				css: (params) => ({
					'> :nth-child(2)': {
						transition: 'opacity 1s',
					},

					[`@container (min-width:${sizes.flipToOneColumn}px)`]: {
						'> :nth-child(2)': {
							...timedFades(params.groupSize, params.cycleTime, params.startingPosition),

							//HACK hover causes the animation to reset so if there are a group of items they will no longer
							//     be coordinated. I believe you can have multiple animations a once. Consider try setting a second
							//     animation on hover...
							'&:hover': {
								animationName: 'unset',
								opacity: '1.0',
							}
						}
					},

					[`@container (max-width:${sizes.flipToOneColumn}px)`]: {
						'> :nth-child(2)': {
							opacity: 0.1,
						}
					},
				}),

				animations: () => [{
					type: 'enable',
					options: {threshold: 0.8},
					css: {
						[`@container (max-width:${sizes.flipToOneColumn}px)`]: {
							'> :nth-child(2)': {
								opacity: 1.0,
							}
						}
					}
				}]
			}]
		}
	};
}

/* startingPosition starts at 1 */
function timedFades(groupSize:number,itemCycleTime/*secs*/:number,startingPosition:number)
{
	const startPos = startingPosition - 1;

//		` + ` ${groupSize * itemCycleTime}s infinite`,
	return {
		animation: keyframes`
			0%  { opacity: 0; }
			${20/groupSize}% { opacity: 1; }
			${80/groupSize}% { opacity: 1; }
			${100/groupSize}% { opacity: 0; }
			100% { opacity: 0; }
		` + ` ${groupSize * itemCycleTime}s infinite`,
		animationDelay: (itemCycleTime * startPos) + 's',
	};
}

